import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";

Vue.config.productionTip = false;

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("./components/HelloWorld.vue")
  },
  {
    path: "/conf/:confId",
    name: "Conf",
    component: () => import("./components/Conf.vue")
  },
  {
    path: "/:catchAll(.*)",
    name: "Page404",
    component: () => import("./components/HelloWorld.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  routes
});

Vue.use(VueRouter);

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
